import { Col, Row } from 'react-bootstrap';
import William from '../../src/assets/william-the-buffalo.jpg';

export const NotFound = () => {
    return (<>
        <Row className="min-vh-85 justify-content-center">
                <Col sm={12} className="mw-520 align-self-center">
                    <div className="my-5">
                        <p className="text-center text-success font-semibold mb-2">PAGE NOT FOUND</p>
                        <h1 className="text-center font-32 mb-5">Huh! Willam can't seem to find that page</h1>
                        <img src={William} className="img-fluid rounded-2xl" alt="William the Buffalo" />
                        <p className="text-gray small px-4 py-3">William the Buffalo</p>
                    </div>
                </Col>
            </Row>
    </>);
};